import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  THEME02: {
    path: `${baseRoutes.userBaseRoutes}theme02`,
  },
};

export default accessRoute;
